import { render, staticRenderFns } from "./size-slider.vue?vue&type=template&id=ea87ccc6&scoped=true&"
import script from "./size-slider.vue?vue&type=script&lang=js&"
export * from "./size-slider.vue?vue&type=script&lang=js&"
import style0 from "./size-slider.vue?vue&type=style&index=0&id=ea87ccc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea87ccc6",
  null
  
)

export default component.exports